import png from './images/broncos.png'

export const colors = {
  dominant: '#6A003A',
  highlight: '#fcb53e',
}
export const fullname = 'Broncos'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/broncos.js